import { Action } from "../Actions/actionRepository";
import { Trigger } from "./triggerRepository";
import * as cookie from "../lib/cookie";

export interface SiteTimeTriggerParam {
    timeOnSite: number;
}

const cookieKey = "sessionStart";
const cookieNS = "trigger";
export class SiteTimeTrigger implements Trigger {
    params: SiteTimeTriggerParam;
    constructor(params: SiteTimeTriggerParam) {
        this.params = params;
    }

    init = (action: Action) => {
        let startDate: Date = new Date();

        if (!cookie.getCookie(cookieNS, cookieKey)) {
            cookie.setSessionCookie(cookieNS, cookieKey, startDate.getTime());
        }

        let currentTimeOut = this.params.timeOnSite * 1000;
        startDate = new Date(Number.parseInt(cookie.getCookie(cookieNS, cookieKey)));
        const endDate = new Date();
        const msDiff: number = Math.round((endDate.getTime() - startDate.getTime()) / 1000);

        currentTimeOut -= msDiff * 1000;

        setTimeout(() => {
            action.execute();
        }, currentTimeOut);
    };
}
